import { Format } from '@helo/cms'

import { toWallClockDateString } from '../../utils/dates'

const date = (value: string): string =>
  Format.date()(toWallClockDateString(value))

const dateRange = (value: string): string => {
  const parts = Format.dateParts({})(toWallClockDateString(value))
  return parts ? `${parts.monthPad}-${parts.dayPad}-${parts.year}` : value
}

const number = Format.number({})

export const FilterDisplayFormatting = {
  date,
  dateRange,
  number,
}
